module.exports = __webpack_public_path__ + "img/img_picture.78dfd10c.png";